export const utmsRanges = [
  { min: -50, max: -72, color: [204, 0, 0] },
  { min: -72, max: -80, color: [255, 51, 0] },
  { min: -80, max: -85, color: [255, 102, 0] },
  { min: -85, max: -89, color: [255, 153, 0] },
  { min: -89, max: -92, color: [255, 204, 0] },
  { min: -92, max: -94, color: [255, 255, 0] },
  { min: -94, max: -95, color: [204, 255, 0] },
  { min: -95, max: -96, color: [153, 255, 0] },
  { min: -96, max: -97, color: [102, 255, 0] },
  { min: -97, max: -97.5, color: [51, 255, 0] },
  { min: -97.5, max: -98, color: [0, 255, 0] },
  { min: -98, max: -99, color: [0, 255, 51] },
  { min: -99, max: -99.5, color: [0, 255, 102] },
  { min: -99.5, max: -100, color: [0, 255, 153] },
  { min: -100, max: -101, color: [0, 255, 204] },
  { min: -101, max: -102, color: [0, 204, 255] },
  { min: -102, max: -102.5, color: [0, 153, 255] },
  { min: -102.5, max: -103, color: [0, 102, 255] },
  { min: -103, max: -104, color: [0, 51, 255] },
  { min: -104, max: -110, color: [0, 0, 255] },
];
